(function () {

    "use strict";

    angular.module('solpheo', [
        "ui.router",
        "ngResource",
        "pascalprecht.translate"
    ]);

}());